import React from 'react'

const STYLES_NOTIFICATION = {
  fontSize: '0.7rem'
}

function BellIcon({
  className,
  stroke,
  onClick,
  notificationCount
}) {

  return (
    <div onClick={onClick} className={`${className} relative`} aria-hidden="true">
      {notificationCount > 0 && (
        <div className='bg-red-500 w-4 h-4 absolute top-0 right-0 transform translate-x-0.5 -translate-y-0.5 rounded-full flex justify-around items-center'>
          <span className='text-white' style={STYLES_NOTIFICATION} >{notificationCount}</span>
        </div>
      )}
      <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke={stroke}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
    </div>
  )
}

export default BellIcon